import { getStoredAuthToken } from "./contexts/AuthContext.jsx";

export function medecinsPayloadToArray(payload) {
  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload?.data)) return payload.data;
  if (Array.isArray(payload?.medecins)) return payload.medecins;
  return [];
}

export function normalizeMedecinMaitre(medecin) {
  const safe = medecin || {};
  const id = typeof safe.id === "string" && safe.id.trim()
    ? safe.id
    : typeof safe.medecin_id === "string" && safe.medecin_id.trim()
    ? safe.medecin_id
    : "";
  const statut = typeof safe.statut_libelle === "string" && safe.statut_libelle.trim()
    ? safe.statut_libelle
    : typeof safe.statut === "string" && safe.statut.trim()
    ? safe.statut
    : "Praticien hospitalier";

  return {
    ...safe,
    id,
    medecin_id: id,
    nom: typeof safe.nom === "string" ? safe.nom : "",
    prenom: typeof safe.prenom === "string" ? safe.prenom : "",
    statut,
    statut_libelle: statut,
    categorie_junior:
      typeof safe.categorie_junior === "string" && safe.categorie_junior.trim()
        ? safe.categorie_junior.trim().toLowerCase()
        : "senior",
    quotite: Number.isFinite(safe.quotite) ? safe.quotite : Number(safe.quotite) || 100,
  };
}

export async function fetchMedecinsMaitre(options = {}) {
  const res = await apiFetch("/api/v2/medecins", options);

  if (!res.ok) {
    const text = await res.text().catch(() => "");
    throw new Error(`HTTP ${res.status}: ${text || "Erreur lecture médecins"}`);
  }

  const payload = await res.json();
  return medecinsPayloadToArray(payload).map(normalizeMedecinMaitre);
}

export async function readApiError(res, fallback) {
  const payload = await res.json().catch(() => null);
  return payload?.message || payload?.error || fallback || `HTTP ${res.status}`;
}

export function apiFetch(path, options = {}) {
  const token = getStoredAuthToken();
  const headers = token
    ? { ...(options.headers || {}), Authorization: `Bearer ${token}` }
    : options.headers;
  const nextOptions = {
    ...options,
    credentials: "include",
  };
  if (headers) nextOptions.headers = headers;
  return fetch(path, nextOptions);
}
